export default __webpack_public_path__ + "static/media/flat_ongkir_icon.8803efeb.svg";